class Monitoring.Models.ModelPaginator extends Backbone.Model

  initialize: (models, perPage) =>
    @models = models
    @perPage = perPage

  page: (selected_page) =>
    selected_page--
    collection = _.rest(@models, @perPage * selected_page)
    collection = _.first(collection, @perPage)
    collection

  total_pages: =>
    model_size = _.size(@models)
    Math.ceil(model_size / @perPage)
